import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import dayjs from 'dayjs';

const CREATED_DATE_FORMAT = 'd.M.y HH:mm';

/*
 * Displays a human-friendly elapsed time for a given date:
 * - "just now" if under 1 minute ago
 * - "X minutes ago" if under 1 hour
 * - "X hours ago" if under 1 day
 * - Otherwise, shows the absolute date/time in a fixed format
 */
@Pipe({
  name: 'elapsedTime'
})
export class ElapsedTimePipe implements PipeTransform {
  constructor(
    private translate: TranslateService,
    private datePipe: DatePipe
  ) {}
  transform(created_at: string): string | null {
    if (created_at) {
      const now = dayjs();
      const dayDiff = now.diff(created_at, 'day');
      const hourDiff = now.diff(created_at, 'hour');
      const minuteDiff = now.diff(created_at, 'minute');

      if (minuteDiff < 1)
        return this.translate.instant('COMMON.LABELS.JUST_NOW');

      if (dayDiff < 1) {
        if (hourDiff < 1) {
          return this.translate.instant('COMMON.LABELS.BEFORE_TIME', {
            time: `${minuteDiff} ${this.translate.instant(
              'COMMON.UNITS.MINUTES'
            )}`
          });
        } else {
          return this.translate.instant('COMMON.LABELS.BEFORE_TIME', {
            time: `${hourDiff} ${this.translate.instant('COMMON.UNITS.HOURS')}`
          });
        }
      } else {
        return this.datePipe.transform(created_at, CREATED_DATE_FORMAT);
      }
    }
    return created_at;
  }
}
